import React, { FC } from 'react';
import { Redirect, RouteComponentProps, Switch } from 'react-router-dom';
import PruRoute from '../../../../common/components/PruRoute';
import ParamsProvider from '../../../../common/components/ParamsProvider';
import AssignedAwardListingPage, { WalletAssignedAwardFilterKeys } from './List/AssignedAwardListingPage';

const WalletAssignedAwardRoutes: FC<RouteComponentProps> = ({ history, location, match }) => {
  return (
    <Switch>
      <Redirect exact from={match.path} to={`${match.path}/list`} />
      <PruRoute
        exact
        path={`${match.path}/list`}
        render={(props) => (
          <ParamsProvider {...props} acceptKeys={WalletAssignedAwardFilterKeys}>
            <AssignedAwardListingPage />
          </ParamsProvider>
        )}
      />
    </Switch>
  );
};

export default WalletAssignedAwardRoutes;
